import { Product, ProductInput, ProductQuery } from '../types'
import createAPIClient from '../services/apiClient'
import { AxiosRequestConfig } from 'axios'

const api = createAPIClient('/v2')

export async function getProducts(
  params?: ProductQuery,
  config?: AxiosRequestConfig
): Promise<Product[]> {
  const response = await api.get(`/products`, {
    params: params,
    ...config
  })

  return response.data
}

export async function getProduct(id: number, config?: AxiosRequestConfig): Promise<Product> {
  const response = await api.get(`/products/${id}`, config)

  return response.data
}

export async function updateProduct<T extends Product = Product>(
  id: number,
  input: ProductInput,
  config?: AxiosRequestConfig
): Promise<T> {
  const response = await api.put<T>(`/products/${id}`, input, config)

  return response.data
}

export async function deleteProduct(id: number, config?: AxiosRequestConfig): Promise<void> {
  await api.delete(`/products/${id}`, config)
}

export default {
  getProducts,
  getProduct,
  updateProduct,
  deleteProduct
}
